import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { EventsZone } from '../../_models/eventsZone';

@Injectable()
export class EventsZoneService {
  private apiBaseUrl = environment.apiBaseUrl;
  // eventZoneList$: Observable<EventsZone[]>;

  constructor(private http: HttpClient) {}

  getEventsZone(zoneId, startDate, endDate): Observable<EventsZone[]> {
    return this.http
      .get<any>(
        this.apiBaseUrl +
          'api/private/v2/insects/events?zoneId=' +
          zoneId +
          '&startDate=' +
          encodeURIComponent(startDate) +
          '&endDate=' +
          encodeURIComponent(endDate)
      )
      .pipe(map((response) => response));
  }

  saveEventsZone(data): Observable<EventsZone> {
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    data.companyId = companySelected ? companySelected.id : null;

    if (data.id) {
      return this.http
        .put(this.apiBaseUrl + 'api/private/v2/insects/events/' + data.id, data)
        .pipe(map((response) => response as EventsZone));
    } else {
      return this.http
        .post(this.apiBaseUrl + 'api/private/v2/insects/events', data)
        .pipe(map((response) => response as EventsZone));
    }
  }

  deleteEventsZone(eventZone: EventsZone): Observable<EventsZone> {
    return this.http
      .delete(
        this.apiBaseUrl +
          'api/private/v2/insects/events/' +
          eventZone.id +
          '?zoneId=' +
          eventZone.zoneId
      )
      .pipe(
        map((response) => {
          if (response) {
            return { id: eventZone.id } as EventsZone;
          }
        })
      );
  }
}
